import { render, staticRenderFns } from "./EmpresaView.vue?vue&type=template&id=34c20828"
import script from "./EmpresaView.vue?vue&type=script&lang=js"
export * from "./EmpresaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports